import * as request from '@/utils/request'

/**
 * 成员详情（用户管理-详情抽屉，系统账号 + 钉钉/飞书绑定信息）
 */

export default {
  /**
   * @description 获取成员详情（基本信息/钉钉信息/飞书信息/时间线）
   * @param {*} id
   * @returns
   */
  getMemberDetail(id) {
    return request.post('/user/member_detail', { id: id })
  },
  /**
   * @description 飞书信息-同步：拉取飞书最新成员信息（只读展示）
   * @param {*} id
   * @returns
   */
  syncFeishuInfo(id) {
    return request.post('/user/sync_feishu_info', { id: id })
  },
  /**
   * @description 飞书信息-更新：应用飞书最新成员信息到系统账号
   * @param {*} id
   * @returns
   */
  updateFeishuInfo(id) {
    return request.post('/user/update_feishu_info', { id: id })
  }
}
